"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshDataAction = void 0;
const react_1 = __importDefault(require("react"));
const actions_1 = require("../actions");
/** Refreshes all data-driven widgets */
class RefreshDataAction extends actions_1.Action {
    validate(designCtx) {
        return null;
    }
    renderEditor(props) {
        return react_1.default.createElement("div", null);
    }
    async performAction(instanceCtx) {
        // Perform refresh
        instanceCtx.database.refresh();
    }
}
exports.RefreshDataAction = RefreshDataAction;
